import moment from 'moment'

import { type IUserSlot } from '@/app/types/settingsTypes'
import { Divider } from '@/shared'

import { Actions } from './Actions/Actions'
import { Logs } from './Logs/Logs'
import { Service } from './Service/Service'
import style from './UserSlots.module.scss'

interface IProps {
    userSlotsList: IUserSlot[]
    searchableAgentId: string
    onRefundRecord: (slotId: string, agentId: string, onSuccess?: () => void) => void
    onSetUserSlotsList: (userSlotsList: IUserSlot[] | null) => void
}

export const UserSlots = (props: IProps) => {
    const { userSlotsList, searchableAgentId, onRefundRecord, onSetUserSlotsList } = props
    return (
        <div className={style.container}>
            {userSlotsList.map((slot) => {
                const { slotId, employeeFIO, recordAt, logs, service } = slot
                const onHandleRefundRecord = () => {
                    const onSuccess = () => {
                        onSetUserSlotsList(userSlotsList.filter((item) => item.slotId !== slotId))
                    }
                    onRefundRecord(slotId, searchableAgentId, onSuccess)
                }
                return (
                    <div key={slotId} className={style.itemWrapper}>
                        <div className={style.param}>
                            <span className={style.key}>Доктор: </span>
                            <span className={style.value}>{employeeFIO || 'Дежурный врач'}</span>
                        </div>
                        <div className={style.divider}>
                            <Divider />
                        </div>
                        <div className={style.param}>
                            <span className={style.key}>Дата записи: </span>
                            <span className={style.value}>{moment(recordAt).format('DD.MM.YYYY HH:mm')}</span>
                        </div>
                        <div className={style.divider}>
                            <Divider />
                        </div>
                        <Service {...service} />
                        <div className={style.divider}>
                            <Divider />
                        </div>
                        <Logs logs={logs} />
                        <div className={style.divider}>
                            <Divider />
                        </div>
                        <Actions onHandleRefundRecord={onHandleRefundRecord} />
                    </div>
                )
            })}
        </div>
    )
}
